export const EMAIL_TEMPLATE_FIELDS = {
  // TODO: Change to fields that BE provide
  name: "Name",
  projectName: "Project Name",
  website: "Website",
  agentWhatsapp: "Agent WhatsApp",
  saleTeamInfo: "Sale team info",
  domain: "Domain",
  customerEmail: "Customer email",
  customerPhone: "Customer phone",
};
